export const LOGS_RESET_STATE = 'LOGS_RESET_STATE';
export const LOGS_CURRENT_ITEM = 'LOGS_CURRENT_ITEM';
 
export const LOGS_REQUEST_LOADING = 'LOGS_REQUEST_LOADING';
export const LOGS_REQUEST_SUCCESS = 'LOGS_REQUEST_SUCCESS';
export const LOGS_REQUEST_FAILED = 'LOGS_REQUEST_FAILED';
 
export const LOGS_CURRENT_ACTION = 'LOGS_CURRENT_ACTION';
export const LOGS_RESET_ACTION = 'LOGS_RESET_ACTION';